module.exports = __webpack_public_path__ + "img/nodejs.5544a2b3.png";